import { IconSuccess16 } from '@cian/ui-kit/icons';
import { ModalWindow } from '@cian/ui-kit/modal';
import * as React from 'react';

import { SORT_TYPE_BUTTONS } from './buttons';
import * as styles from './styles.css';
import { EOrderField } from '../../types/filters';

interface IDealTypeSortModal {
  orderField?: EOrderField | null;
  open: boolean;
  setFilterOrder(orderField: EOrderField | null): void;
  closeSort(): void;
}

export const DealTypeSortModal: React.FC<IDealTypeSortModal> = ({ orderField, open, setFilterOrder, closeSort }) => {
  const setFiltersOrderType = (order: EOrderField) => {
    setFilterOrder(order);
    closeSort();
  };

  return (
    <ModalWindow
      title="Сортировка"
      content={
        <div className={styles['sort-container']}>
          <ul className={styles['sort-list']}>
            {SORT_TYPE_BUTTONS.map(button => (
              <li
                key={button.value}
                className={styles['sort-list-item']}
                onClick={() => {
                  setFiltersOrderType(button.value);
                }}
              >
                {button.label}
                {button.value === orderField && <IconSuccess16 color="primary_100" />}
              </li>
            ))}
          </ul>
        </div>
      }
      open={open}
      onClose={closeSort}
    />
  );
};
